document.addEventListener('turbolinks:load', () => {
  $('#intercom-link').on('click', () => {
    if (typeof window.Intercom !== 'undefined') {
      window.Intercom('show');
    } else {
      alert('In production, opens Intercom.');
    }
  });
});
